import gsap from 'gsap'

const getMaxDigitWidth = el => {
  let max = 0
  const div = document.createElement('div')

  gsap.set(div, {
    position: 'absolute',
    pointerEvents: 'none',
    opacity: 0,
  })

  el.append(div)

  for (let i = 0; i <= 9; i += 1) {
    div.innerHTML = i.toString()

    if (div.offsetWidth > max) {
      max = div.offsetWidth
    }
  }

  return max
}

export default function counterAnimation(section) {
  const animationBlocks = section.querySelectorAll('[data-counter-animation]')
  const circles = section.querySelectorAll('[data-circle-animation]')
  const counterTl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top bottom',
    },
  })
  const circleTl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top bottom',
    },
  })

  const delay = section.dataset.stagger

  animationBlocks.forEach((block, i) => {
    const { from, to } = block.dataset
    const counter = { score: from }
    const maxDigitWidth = getMaxDigitWidth(block)

    gsap.set(block, {
      width: maxDigitWidth * to.length,
      textAlign: 'right',
    })

    counterTl.to(
      counter,
      {
        score: +to,
        snap: 'score',
        ease: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        duration: 3.5,
        onUpdate: () => {
          block.innerHTML = counter.score
        },
      },
      +delay * i
    )
  })

  circles.forEach((circle, i) => {
    const totalPath =
      2 * Math.PI * +circle.querySelector('circle').getAttribute('r')

    gsap.set(circle, {
      strokeDasharray: totalPath,
      strokeDashoffset: totalPath,
    })

    circleTl.to(
      circle,
      {
        duration: 3.5,
        strokeDashoffset: 0,
      },
      +delay * i
    )
  })
}
